import { RiskIndexVariantType } from '../../../../../../components/riskIndex/types/riskIndexVariantType';
export const getDefaultStyles = (FOUNDATIONS, FONT, SHADOWS) => {
    return {
        [RiskIndexVariantType.DEFAULT]: {
            rootContainer: {
                display: 'flex',
                flex_direction: 'column',
                width: '100%',
                background_color: FOUNDATIONS.color_neutral_bg_static_100,
            },
            topContentContainer: {
                display: 'flex',
                width: '100%',
                padding: FOUNDATIONS.spacing_150,
                border_left: `${FOUNDATIONS.border_25} solid ${FOUNDATIONS.color_comp_legal_riskindex_border}`,
                border_top: `${FOUNDATIONS.border_25} solid ${FOUNDATIONS.color_comp_legal_riskindex_border}`,
                border_right: `${FOUNDATIONS.border_25} solid ${FOUNDATIONS.color_comp_legal_riskindex_border}`,
            },
            mainAndRightContentContainer: {
                display: 'flex',
                flex_direction: 'row',
                width: '100%',
                border: `${FOUNDATIONS.border_25} solid ${FOUNDATIONS.color_comp_legal_riskindex_border}`,
            },
            mainContentContainer: {
                display: 'flex',
                align_items: 'flex-end',
                width: '100%',
                padding: FOUNDATIONS.spacing_150,
            },
            rightContentContainer: {
                display: 'flex',
                align_items: 'flex-end',
                width: '100%',
                padding: FOUNDATIONS.spacing_150,
                border_left: `${FOUNDATIONS.border_25} solid ${FOUNDATIONS.color_comp_legal_riskindex_border}`,
            },
            bottomContentContainer: {
                display: 'flex',
                width: '100%',
                padding: FOUNDATIONS.spacing_150,
                border_left: `${FOUNDATIONS.border_25} solid ${FOUNDATIONS.color_comp_legal_riskindex_border}`,
                border_right: `${FOUNDATIONS.border_25} solid ${FOUNDATIONS.color_comp_legal_riskindex_border}`,
                border_bottom: `${FOUNDATIONS.border_25} solid ${FOUNDATIONS.color_comp_legal_riskindex_border}`,
            },
        },
    };
};
//# sourceMappingURL=default.js.map